import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useUser } from '../context/UserContext';

export default function useAvatar() {
  const { user } = useUser();
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);

  useEffect(() => {
    const loadAvatar = async () => {
      if (!user) return;
      
      // Check for active session before making request
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) return;
      
      const { data, error } = await supabase
        .from('users')
        .select('avatar')
        .eq('id', user.id)
        .single();
      if (!error && data?.avatar) {
        setAvatarUrl(data.avatar);
      } else {
        setAvatarUrl(null);
      }
    };
    loadAvatar();
  }, [user]);

  return avatarUrl;
}
